var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgDocumentIcon = function SvgDocumentIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.59961,
    y: 4.80005,
    width: 20.8,
    height: 22.4,
    rx: 1,
    stroke: "#054BC7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98781 21.8199C10.3785 21.2133 10.73 20.5739 11.1519 19.9903C11.4004 19.6467 11.6891 19.311 12.169 19.3069C12.4912 19.3041 12.6787 20.7662 12.7219 21.0188C12.8224 21.6065 12.8995 22.496 13.534 22.8542C14.6528 23.4859 15.5379 21.739 15.7611 21.0081C15.8055 20.863 16.043 20.1813 16.3036 20.4409C16.6587 20.7945 16.8125 21.4804 17.3317 21.4718C17.9072 21.4622 18.3598 21.2437 18.8037 20.9354C19.215 20.6498 19.5136 20.146 19.9755 19.9337C20.4834 19.7003 21.2663 20.0524 21.8119 20.1869",
    stroke: "#054BC7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1005 10.1334H21.9707",
    stroke: "#054BC7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1005 13.9152H21.9707",
    stroke: "#054BC7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNS41OTk2MSIgeT0iNC44MDAwNSIgd2lkdGg9IjIwLjgiIGhlaWdodD0iMjIuNCIgcng9IjEiIHN0cm9rZT0iIzA1NEJDNyIgc3Ryb2tlLXdpZHRoPSIxLjI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTkuOTg3ODEgMjEuODE5OUMxMC4zNzg1IDIxLjIxMzMgMTAuNzMgMjAuNTczOSAxMS4xNTE5IDE5Ljk5MDNDMTEuNDAwNCAxOS42NDY3IDExLjY4OTEgMTkuMzExIDEyLjE2OSAxOS4zMDY5QzEyLjQ5MTIgMTkuMzA0MSAxMi42Nzg3IDIwLjc2NjIgMTIuNzIxOSAyMS4wMTg4QzEyLjgyMjQgMjEuNjA2NSAxMi44OTk1IDIyLjQ5NiAxMy41MzQgMjIuODU0MkMxNC42NTI4IDIzLjQ4NTkgMTUuNTM3OSAyMS43MzkgMTUuNzYxMSAyMS4wMDgxQzE1LjgwNTUgMjAuODYzIDE2LjA0MyAyMC4xODEzIDE2LjMwMzYgMjAuNDQwOUMxNi42NTg3IDIwLjc5NDUgMTYuODEyNSAyMS40ODA0IDE3LjMzMTcgMjEuNDcxOEMxNy45MDcyIDIxLjQ2MjIgMTguMzU5OCAyMS4yNDM3IDE4LjgwMzcgMjAuOTM1NEMxOS4yMTUgMjAuNjQ5OCAxOS41MTM2IDIwLjE0NiAxOS45NzU1IDE5LjkzMzdDMjAuNDgzNCAxOS43MDAzIDIxLjI2NjMgMjAuMDUyNCAyMS44MTE5IDIwLjE4NjkiIHN0cm9rZT0iIzA1NEJDNyIgc3Ryb2tlLXdpZHRoPSIxLjI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjEwMDUgMTAuMTMzNEgyMS45NzA3IiBzdHJva2U9IiMwNTRCQzciIHN0cm9rZS13aWR0aD0iMS4yNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMC4xMDA1IDEzLjkxNTJIMjEuOTcwNyIgc3Ryb2tlPSIjMDU0QkM3IiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";